import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { setMockSession } from "../auth/auth";
import { Button, Card, LoadingState, PageHeader } from "../components/ui";
import { clientIdForHost, isMock } from "../config";
import { MOCK_ME } from "../mocks/fixtures";

/**
 * One quiet card: the product's name, one action. Managed login does the
 * rest on `auth.<zone>` — password + authenticator, or a passkey — so
 * nothing here collects a credential. In mock builds, two personas.
 */
export function LoginPage() {
  const { status, signIn, config, me } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } } | null)?.from?.pathname ?? "/";
  if (status === "signed-in") return <Navigate to={from} replace />;
  if (status === "loading") return <LoadingState label="Signing in…" />;
  const canSignIn = isMock || !!clientIdForHost(config);
  const productName = me?.tenant.productName ?? config.productName;
  return (
    <>
      <PageHeader title={`Sign in to ${productName}`} subtitle="You will be asked for your password and authenticator app, or your passkey." />
      <Card className="max-w-md">
        {isMock ? (
          <div className="space-y-3">
            <p className="text-sm text-muted">Mock sign-in (local development and tests).</p>
            <Button
              variant="primary"
              className="w-full"
              onClick={() => {
                setMockSession(MOCK_ME.apprentice);
                window.location.assign(from);
              }}
            >
              Continue as apprentice
            </Button>
            <Button
              className="w-full"
              onClick={() => {
                setMockSession(MOCK_ME["staff-sso"]);
                window.location.assign(from);
              }}
            >
              Continue as staff (SSO)
            </Button>
          </div>
        ) : canSignIn ? (
          <Button variant="primary" className="w-full" onClick={() => void signIn(from)}>
            Sign in
          </Button>
        ) : (
          <p className="text-muted">This address is not a tenant's sign-in page. Use the address you were given.</p>
        )}
      </Card>
    </>
  );
}
